import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SkillsDisplayProps {
  charisma: number
  admin_skill: number
  debate_skill: number
  className?: string
}

interface SkillInfo {
  key: 'charisma' | 'admin_skill' | 'debate_skill'
  label: string
  description: string
}

const SKILLS: SkillInfo[] = [
  {
    key: 'charisma',
    label: 'Charisma',
    description: 'Campaign effectiveness, media presence',
  },
  {
    key: 'admin_skill',
    label: 'Admin Skill',
    description: 'Governing ability, ministry performance',
  },
  {
    key: 'debate_skill',
    label: 'Debate Skill',
    description: 'Attack/defense actions, debates',
  },
]

function getSkillColor(value: number): string {
  if (value >= 70) return 'bg-green-500'
  if (value >= 40) return 'bg-yellow-500'
  return 'bg-red-500'
}

export function SkillsDisplay({
  charisma,
  admin_skill,
  debate_skill,
  className,
}: SkillsDisplayProps) {
  const values: Record<string, number> = {
    charisma,
    admin_skill,
    debate_skill,
  }

  // Find the best skill
  const bestSkillKey = SKILLS.reduce((best, skill) =>
    values[skill.key] > values[best.key] ? skill : best
  ).key

  return (
    <div className={cn('space-y-4', className)}>
      {SKILLS.map((skill) => {
        const value = values[skill.key]
        const isBest = skill.key === bestSkillKey

        return (
          <div key={skill.key} className="space-y-1">
            <div className="flex items-center gap-2">
              {isBest && (
                <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
              )}
              <span
                className={cn(
                  'text-sm font-medium',
                  isBest && 'text-yellow-600 dark:text-yellow-400'
                )}
              >
                {skill.label}
              </span>
              {isBest && (
                <span className="text-xs text-muted-foreground">Best skill</span>
              )}
              <span className="ml-auto text-sm font-semibold">{value}</span>
            </div>

            <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
              <div
                className={cn('h-full transition-all', getSkillColor(value))}
                style={{ width: `${value}%` }}
              />
            </div>

            <p className="text-xs text-muted-foreground">{skill.description}</p>
          </div>
        )
      })}
    </div>
  )
}
